import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Griddle, { plugins } from 'griddle-react';
import HotelListItem from './HotelListItem';

function hasHotels(hotels) {
  if (!hotels) {
    return false;
  }
  if (Object.prototype.hasOwnProperty.call(hotels, 'length')) {
    return hotels.length !== 0;
  }
  return false;
}

const CustomTableComponent = OriginalComponent =>
  class CustomTableComponent extends React.Component {
    static contextTypes = {
      components: PropTypes.object,
    };

    render() {
      return <this.context.components.TableBody />;
    }
  };

const CustomTableBody = ({ rowIds, Row, style, className }) => (
  <div style={style} className={className}>
    {rowIds && rowIds.map(r => <Row key={r} griddleKey={r} />)}
  </div>
);
const sortProperties = [
  { id: 'selected', sortAscending: false },
  { id: 'distance', sortAscending: true },
  { id: 'name', sortAscending: true },
];

class HotelList extends React.Component {
  constructor(props) {
    super(props);
    this.selectHotelList = this.selectHotelList.bind(this);
    this.favHotel = this.favHotel.bind(this);
  }
  selectHotelList(hotelId) {
    console.log('select hotel from list', hotelId, this.props.eventId);
    this.props.selectHotel(this.props.eventId, hotelId);
  }
  favHotel(hotelId, fav) {
    this.props.favoriteHotel(hotelId, fav);
  }

  render() {
    const CustomRowComponent = connect((state, props) => ({
      rowData: plugins.LocalPlugin.selectors.rowDataSelector(state, props),
    }))(({ rowData }) => (
      <HotelListItem
        hotel={rowData}
        selectHotel={this.selectHotelList}
        favoriteHotel={this.favHotel}
        displayHotel={this.props.displayHotel}
      />
    ));
    if (!hasHotels(this.props.hotels)) {
      return <p>No hotels found. Please modify your search preferences.</p>;
    }

    return (
      <Griddle
        data={this.props.hotels}
        pageProperties={{
          pageSize: 100,
        }}
        plugins={[plugins.LocalPlugin]}
        sortProperties={sortProperties}
        components={{
          Row: CustomRowComponent,
          TableContainer: CustomTableComponent,
          TableBody: CustomTableBody,
          SettingsToggle: () => <span />,
        }}
      />
    );
  }
}

HotelList.propTypes = {
  hotels: PropTypes.arrayOf(PropTypes.object).isRequired,
  eventId: PropTypes.number.isRequired,
  selectHotel: PropTypes.func.isRequired,
  favoriteHotel: PropTypes.func.isRequired,
  displayHotel: PropTypes.func.isRequired,
};

HotelList.defaultProps = {
  hotels: [],
};
export default HotelList;



// WEBPACK FOOTER //
// src/routes/tours/components/HotelList.js